import config from '../../config';
import { makeAPICall, APIError } from '../generalCreators';

export function getShapeSetIndustries(shapeSetId, isAllocatedTo = true, excludeArchived = false) {
  return function(dispatch, getState) {
    const endpoint = '/industries';
    const options = {
      method: "GET",
      headers: { token: getState().authentication.token },
      params: {
        productId: config.productId,
        isAllocatedTo,
        shapeSetId
      }
    };

    return makeAPICall(endpoint, options).then(
      response => {
        const industries = response.data.industries;
        const type = isAllocatedTo ? 'UPDATE_CURRENT_SHAPESET_ALLOCATED_INDUSTRIES' : 'UPDATE_CURRENT_SHAPESET_UNALLOCATED_INDUSTRIES';
        dispatch({ type, industries});
      },
      error => dispatch(APIError(error, 'Error getting currentShapeSet Industries'))
    );
  }
}

export function addIndustryToShapeSet(shapeSetId, industryId) {
  return function(dispatch, getState) {
    const endpoint = '/shapeset/membership/industry';
    const options = {
      method: "POST",
      headers: { token: getState().authentication.token },
      params: { productId: config.productId },
      data: {
        shapeSetId,
        industryId
      }
    };

    return makeAPICall(endpoint, options).then(
      response => {
        // update both allocated and unallocated orgs
        dispatch(getShapeSetIndustries(shapeSetId, true));
        dispatch(getShapeSetIndustries(shapeSetId, false));
        return response;
      },
      error => dispatch(APIError(error, 'Error adding Industry to currentShapeSet'))
    );
  }
}

export function removeIndustryFromShapeSet(shapeSetId, industry) {
  return function(dispatch, getState) {
    const endpoint = `/shapeset/membership/industry/${industry.membershipId}`;
    const options = {
      method: "PUT",
      headers: { token: getState().authentication.token },
      params: { productId: config.productId },
      data: { isArchived: true }
    };

    return makeAPICall(endpoint, options).then(
      response => {
        // update both allocated and unallocated orgs
        dispatch(getShapeSetIndustries(shapeSetId, true));
        dispatch(getShapeSetIndustries(shapeSetId, false));
        return response;
      },
      error => dispatch(APIError(error, 'Error removing Industry from currentShapeSet'))
    );
  }
}


// WEBPACK FOOTER //
// ./src/actions/shapeSets/industryCreators.js